import { Pipe, PipeTransform } from '@angular/core';
import { AdditionalValidators } from '@helpers/shared/validators';

@Pipe({
	name: 'phoneNumber',
	standalone: false
})
export class PhoneNumberPipe implements PipeTransform {
	transform(value: string): string {
		if (!value) return '';

		const digits = value.replace(/\D/g, '');

		const isValid = AdditionalValidators.e164Regex.test(digits);

		if (!isValid) {
			return value;
		}

		if (digits.length >= 11) {
			const countryCode = digits.substring(0, 1);
			const areaCode = digits.substring(1, 4);
			const firstPart = digits.substring(4, 7);
			const secondPart = digits.substring(7, 9);
			const thirdPart = digits.substring(9, 11);

			return `${countryCode} (${areaCode}) ${firstPart}-${secondPart}-${thirdPart}`;
		} else if (digits.length >= 7) {
			const countryCode = digits.substring(0, 1);
			const areaCode = digits.substring(1, 4);
			const firstPart = digits.substring(4, 7);
			const remaining = digits.substring(7);

			return `${countryCode} (${areaCode}) ${firstPart}-${remaining}`;
		} else {
			return value;
		}
	}
}
